























































import {
  Component, Prop, Vue, PropSync,
} from 'vue-property-decorator';
import { MarketApi, PartnerApi } from '@compassdigital/foodworks.api.ts';
import { UserApi, User } from '@compassdigital/foodworks.ts.sdk';
import { mixins } from 'vue-class-component';
import AppModule from '@/store/modules/app';
import UserModule from '@/store/modules/user';
import Dropdown from '@/components/Form/Dropdown/index.vue';
import MarketUtil from '@/util/MarketUtil';
import Textfield from '@/components/Form/Textfield/index.vue';
import { IMarketInfo, IMarketScoutInfo } from '@/interface/marketInfo';
import SystemModule from '@/store/modules/system';
import Format from '@/util/Format';
import UnitsUtil from '@/util/UnitUtil';
import PermissionMixin from '../../../../mixins/PermissionMixin';

@Component({
  components: {
    Dropdown,
    Textfield,
  },
})
export default class AdminInformationEdit extends mixins(PermissionMixin) {
  @Prop({ default: '56px' }) public height!: string;

  @Prop({ default: '531px' }) public width!: string;

  @PropSync('marketInfo', {}) marketInfoSync!: any;

  private errors:string = '';

  private loading:boolean = false;

  private marketItems:any = [];

  private scoutItems: any[] = [];

  private scoutUserItems: any[] = [];

  marketRules = [(v: any) => !!v || 'Market is required'];

  partnersRules = [(v: any) => !!v || 'Partner type is required'];

  scoutRules = [(v: any) => !!v || 'Scout name is required'];

  private partnersTypes = [
    {
      text: 'Restaurant',
      value: 'restaurant',
    },
    {
      text: 'Food Truck',
      value: 'foodtruck',
    },
  ];

  public mounted() {
    this.getMarkets();
    this.getScouts();
  }

  public async getMarkets() {
    try {
      this.loading = true;
      if (AppModule.isLoggedIn && AppModule.accessToken) {
        try {
          const { markets }: any = SystemModule;
          const items = MarketUtil.getMappedMarkets(markets);
          this.marketItems = Format.sortedItems(items);
        } catch (err) {
          throw err;
        }
      }
    } catch (err) {
      if (err.error) {
        this.errors = err.error;
      }
    }
    this.loading = false;
  }

  public async getScouts() {
    try {
      this.loading = true;
      if (AppModule.isLoggedIn && AppModule.accessToken) {
        try {
          const api = new UserApi(AppModule.apiConfig);
          const users = await api.getUsers();
          ((this.scoutItems) as any) = UnitsUtil.scoutListFormatted(users.data);
          const scoutUsers = await api.getUser(UserModule.userId);
          ((this.scoutUserItems) as any) = Format.usersFwEmployee(scoutUsers.data as any);
        } catch (err) {
          throw err;
        }
      }
    } catch (err) {
      if (err.error) {
        this.errors = err.error;
      }
    }
    this.loading = false;
  }
}
